import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Modal, Select, Menu, Dropdown, Spin} from 'antd'
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  LockOutlined,
  QuestionCircleFilled,
  SearchOutlined,
  UnlockOutlined,
  EllipsisOutlined
} from '@ant-design/icons'
import {getPaginationConfig} from '../../components/pagination'
import RulesModal from './components/RulesModal'
import {inject, observer} from 'mobx-react'
import SQLModal from './components/SQLModal'
import LogModal from './components/LogModal'
import VersionModal from './components/VersionModal'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
const {confirm} = Modal

@inject('rulesManagementStore')
@observer
class rulesManagement extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页条数
    total: null, // 总条数
    rulesModalType: '',
    SQLModalType: '',
    rulesModalVisible: false,
    SQLModalVisible: false,
    logModalVisible: false,
    versionModalVisible: false,
    ruleId: null,
    SQLId: null,
    ruleName: null,
    ruleType: null
  }
  formRef = React.createRef()

  componentDidMount() {
    const {rulesManagementStore} = this.props
    rulesManagementStore.getDropdown('RuleTypeEnum')
    rulesManagementStore.getDropdown('RuleTriggerStatusEnum')
    rulesManagementStore.getTableNameLinkage()
    this.handleSearch(1, 10)
  }

  handleCancel = (target) => {
    this.setState({[target]: false})
  }

  handleSearch = (page, size) => {
    const {rulesManagementStore} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        ...fieldsValue,
        current: page ? page : this.state.page,
        pageSize: size ? size : this.state.size,
      }
      rulesManagementStore.getRuleData(params).then(res => {
        if (res?.data) {
          const {data} = res?.data
          this.setState({
            page: data.current, // 当前页
            size: data.size, // 每页显示条数
            total: data.total // 总条数
          })
        }
      })
    })
  }

  handleDel = id => {
    const {rulesManagementStore, t} = this.props
    let _this = this

    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        rulesManagementStore.deleteRule({id}).then(() => {
          _this.handleSearch()
        })
      }
    })
    return false
  }

  onAddButtonClick = e => {
    if (e.key === 'addRule') {
      this.setState({rulesModalVisible: true, rulesModalType: 'add'})
    } else {
      this.setState({SQLModalVisible: true, SQLModalType: 'add'})
    }
  }

  onEditButtonClick = record => {
    const {rulesManagementStore} = this.props

    if (record?.ruleType === 'Rule') {
      rulesManagementStore.getRuleDetail({id: record.id}).then(res => {
        if (res?.data?.code === 0) {
          this.setState({rulesModalVisible: true, rulesModalType: 'edit', ruleId: record.id})
        }
      })
    } else {
      rulesManagementStore.getSQLDetail({id: record.id}).then(res => {
        if (res?.data?.code === 0) {
          this.setState({SQLModalVisible: true, SQLModalType: 'edit', SQLId: record.id})
        }
      })
    }
  }

  handleActive = record => {
    const {rulesManagementStore} = this.props

    rulesManagementStore.onActiveChange({id: record.id, active: record.active ? 0 : 1}).then(res => {
      if (res?.data?.code === 0) {
        this.handleSearch()
      }
    })
  }

  showRuleLog = record => {
    const {rulesManagementStore} = this.props
    rulesManagementStore.getRuleStatusLog(record.id).then(res => {
      if (res?.data?.code === 0) {
        this.setState({logModalVisible: true, ruleName: record.ruleName})
      }
    })
  }

  handleVersion = record => {
    const {rulesManagementStore} = this.props
    rulesManagementStore.getVersionList(record.id).then(res => {
      if (res?.data?.code === 0) {
        this.setState({versionModalVisible: true, ruleName: record.ruleName, ruleId: record.id, ruleType: record.ruleType})
      }
    })
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  inputFilter = (input, option) => {
    return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {rulesManagementStore, location, t} = this.props
    const items = [
      {label: t(`rulesManagement.addFormalRule`), key: 'addRule'},
      {label: t(`rulesManagement.addSqlRule`), key: 'addSQL'}
    ]
    const addButton = (
      <Menu className="rulesAddButton" onClick={this.onAddButtonClick} items={items}/>
    )

    const {
      rulesModalType,
      page,
      size,
      total,
      rulesModalVisible,
      ruleId,
      SQLModalVisible,
      SQLModalType,
      SQLId,
      logModalVisible,
      versionModalVisible,
      ruleName,
      ruleType
    } = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)
    const {typeList, tableList, tableData, isFetching, statusList} = rulesManagementStore

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
            <div className="searchFormTitle">
              <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
            </div>
            <Row gutter={[10, 0]}>
              <Col span={6}>
                <Form.Item name="ruleName" label={t(`rulesManagement.ruleName`)}
                           rules={[{
                             message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.ruleName`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="ruleType" label={t(`rulesManagement.type`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {typeList.map(item => <Select.Option key={item.code} value={item.code}>{item.name}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="tableName" label={t(`rulesManagement.tableName`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>
                    {tableList.map(item => <Select.Option key={item.tableName} value={item.tableName}>{item.tableName}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="triggerStatus" label={t(`rulesManagement.status`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch
                          filterOption={(input, option) => this.inputFilter(input, option)}>
                    {statusList.map(item => <Select.Option key={item.code} value={item.code}>{item.name}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} style={{textAlign: 'right', paddingBottom: 10}}>
                <Button style={{marginRight: 10}} onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
                <Dropdown overlay={addButton} trigger={['click']}>
                  <Button type="primary">{t(`general.add`)}</Button>
                </Dropdown>
              </Col>
            </Row>
          </Form>

          <Table className="searchResult" dataSource={tableData} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>
            <Table.Column align="center" width={80} title={t(`rulesManagement.status`)} dataIndex="triggerStatusName" key="triggerStatusName"
                          ellipsis={true}
                          render={(text, record, index) =>
                            <div style={{
                              display: 'inline-block',
                              height: 24,
                              width: 24,
                              lineHeight: '24px',
                              fontSize: 12,
                              borderRadius: 24,
                              color: 'white',
                              textAlign: 'center',
                              background: text === 'SUCCESS' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'FAILED' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : themeStyle?.statusColor?.split(',')?.[2] || '#7ac3e0'
                            }}
                                 title={text}>{text.charAt(0)}</div>
                          }/>
            <Table.Column title={t(`rulesManagement.ruleName`)} dataIndex="ruleName" key="ruleName" ellipsis={true} render={(text, record) => {
              return (
                <span style={{cursor: 'pointer', color: '#003ca7'}} onClick={() => this.showRuleLog(record)}>{record?.ruleName}</span>
              )
            }}/>
            <Table.Column width={80} title={t(`rulesManagement.type`)} dataIndex="ruleType" key="ruleType" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.tableName`)} dataIndex="tableName" key="tableName" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.creator`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.triggerType`)} dataIndex="triggerType" key="triggerType" ellipsis={true}/>
            <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
              return (
                <>
                  <Button type="link" onClick={() => this.onEditButtonClick(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
                  <Button type="link" onClick={() => this.handleActive(record)} className={record.active !== 1 ? null : 'grey'}
                          icon={record.active !== 1 ? <UnlockOutlined/> : <LockOutlined/>}
                          title={record.active !== 1 ? t(`general.active`) : t(`general.inactive`)}/>

                  <Dropdown overlay={<Menu items={
                    record?.mappingAttributeAlias !== 'OnlyCopy' ? [
                      {label: t(`general.version`), key: 'version', icon: <InfoCircleOutlined/>, onClick: () => this.handleVersion(record)},
                      {label: t(`general.delete`), key: 'delete', icon: <DeleteOutlined/>, onClick: () => this.handleDel(record)}
                    ] : [
                      {label: t(`general.delete`), key: 'delete', icon: <DeleteOutlined/>, onClick: () => this.handleDel(record)}
                    ]
                  }/>}>
                    <Button type="link" icon={<EllipsisOutlined/>}/>
                  </Dropdown>
                </>
              )
            }}/>
          </Table>

          {
            rulesModalVisible ?
              <RulesModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} rulesModalVisible ruleId={ruleId}
                          rulesModalType={rulesModalType}/> : null
          }
          {
            SQLModalVisible ?
              <SQLModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} SQLModalVisible SQLId={SQLId}
                        SQLModalType={SQLModalType}/> : null
          }
          {
            logModalVisible ?
              <LogModal handleCancel={this.handleCancel} logModalVisible ruleName={ruleName}/> : null
          }
          {
            versionModalVisible ?
              <VersionModal handleCancel={this.handleCancel} versionModalVisible ruleName={ruleName} ruleId={ruleId} ruleType={ruleType}/> : null
          }
        </div>
      </Spin>
    )
  }
}

export default withTranslation()(rulesManagement)
